import { render, staticRenderFns } from "./dialogue-info.vue?vue&type=template&id=e36b5da2"
import script from "./dialogue-info.vue?vue&type=script&lang=js"
export * from "./dialogue-info.vue?vue&type=script&lang=js"
import style0 from "./dialogue-info.vue?vue&type=style&index=0&id=e36b5da2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports